import styled from 'styled-components';
import { boxShadow } from 'js/config/style';

export default styled.div`
  background: white;
  box-shadow: ${boxShadow};
  border-radius: 0.25rem;
  padding: 2rem;
  margin-bottom: 2rem;
`;
